import { render, staticRenderFns } from "./ReviewMobileModal.vue?vue&type=template&id=7a490df7&scoped=true&"
import script from "./ReviewMobileModal.vue?vue&type=script&lang=js&"
export * from "./ReviewMobileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a490df7",
  null
  
)

export default component.exports